// extracted by mini-css-extract-plugin
module.exports = {"drawer":"PaymentsDrawer_drawer__okqY6","content":"PaymentsDrawer_content__2Yqzq","spinner":"PaymentsDrawer_spinner__3sCMS","drawerLoading":"PaymentsDrawer_drawerLoading__2h_SH"};